<div class="card">
    <div class="card-header">
        <h4>Merchant Details</h4>
    </div>
    <div class="card-body m-0">
        <div class="bg-primary text-white p-2 rounded">
            <div class="row">
                <div class="col-xl-4 align-content-center">Merchant Details ({{merchantDetails?.businessName}})</div>
                <div class="col-xl-8 text-end">
                    <div class="btn-group mb-1 mb-md-0">
                        <div class="btn-group">
                            <button type="button" class="btn bg-danger-custom" (click)="save()">
                                Save
                            </button>
                        </div>
                    </div>
                    <div class="btn-group mb-1 mb-md-0">
                        <div class="btn-group">
                            <button class="btn bg-danger-custom" [routerLink]="['/merchants/account']">Cancel</button>
                        </div>
                    </div>
                    <!-- <div class="btn-group mb-1 mb-md-0">
                        <div class="btn-group">
                            <button class="btn bg-danger-custom">Reset All</button>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>

        <div class="mt-2">
            <ngb-accordion #acc="ngbAccordion" [activeIds]="activePanel" [closeOthers]="true"
                (panelChange)="changePanel($event)">
                <ngb-panel cardClass="new-item" *ngFor="let item of accordions;let i=index;" [id]="item.title+'-'+i">
                    <ng-template ngbPanelTitle>
                        <span> {{item.title}}</span>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="row g-3" [formGroup]="merchantForm">
                            <ng-container *ngFor="let controlsN of item.formControls">
                                <div class="col-md-6" *ngIf="controlsN.type==='text' && controlsN.controlName!=='autoMin'">
                                    <label class="col-form-label" for="{{controlsN?.controlName}}">{{controlsN.name}}
                                        <span aria-hidden="true" class="symbol required" *ngIf="controlsN.required" style="color:red;">*</span>
                                    </label>
                                    <input type="text" class="form-control" id="{{controlsN?.controlName}}"
                                        placeholder="{{controlsN.name}}" [formControlName]="controlsN.controlName" />
                                    <div style="display: block;"
                                        *ngIf="submitted && merchantFormControls?.[controlsN.controlName]?.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="merchantFormControls?.[controlsN.controlName]?.errors?.required">
                                            {{controlsN.name}} is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6" *ngIf="controlsN.type==='text' && controlsN.controlName==='autoMin'">
                                    <label class="col-form-label" for="{{controlsN?.controlName}}">{{controlsN.name}}
                                        <span aria-hidden="true" class="symbol required" *ngIf="controlsN.required" style="color:red;">*</span>
                                    </label>
                                    <input class="form-control" [formControlName]="controlsN.controlName"
                                        id="{{controlsN.controlName}}" placeholder="{{controlsN.name}}" type="text"
                                        mask="Hh:m0" >
                                        <!-- mask="Hh:m0" [dropSpecialCharacters]="false"> -->
                                    <div style="display: block;"
                                        *ngIf="submitted && merchantFormControls?.[controlsN.controlName]?.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="merchantFormControls?.[controlsN.controlName]?.errors?.required">
                                            {{controlsN.name}} is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6" *ngIf="controlsN.type==='select' && merchantForm?.value?.hasOwnProperty(controlsN?.controlName)">
                                    <label class="col-form-label" for="{{controlsN?.controlName}}">{{controlsN.name}}
                                        <span aria-hidden="true" class="symbol required" *ngIf="controlsN.required" style="color:red;">*</span>
                                    </label>
                                    <ng-select [clearable]="false" [formControlName]="controlsN?.controlName"  (change)="onChangeSelect(controlsN?.controlName,$event)"
                                        id="{{controlsN?.controlName}}" placeholder="Select {{controlsN?.name}}"
                                        [inputAttrs]="{maxlength: '100'}">
                                        <ng-option *ngFor="let val of controlsN.data"
                                            value="{{val.key}}">{{val.value}}</ng-option>
                                    </ng-select>
                                    <div style="display: block;"
                                        *ngIf="submitted && merchantFormControls?.[controlsN.controlName]?.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="merchantFormControls?.[controlsN.controlName]?.errors?.required">
                                            Please select {{controlsN.name}}.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6" *ngIf="controlsN.type==='textarea'">
                                    <label class="col-form-label" for="{{controlsN?.controlName}}">{{controlsN.name}}
                                        <span aria-hidden="true" class="symbol required" *ngIf="controlsN.required" style="color:red;">*</span>
                                    </label>
                                    <textarea name="{{controlsN?.controlName}}" class="form-control"
                                        id="{{controlsN?.controlName}}" placeholder="{{controlsN.name}}"
                                        [formControlName]="controlsN.controlName">
                                    </textarea>
                                    <div style="display: block;"
                                        *ngIf="submitted && merchantFormControls?.[controlsN.controlName]?.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="merchantFormControls?.[controlsN.controlName]?.errors?.required">
                                            {{controlsN.name}} is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6"
                                    *ngIf="controlsN.type==='checkbox' && controlsN.controlName!=='tncStatus' && controlsN.controlName!=='autoFlag' && controlsN.controlName!=='notificationApiEnableFlag' && controlsN.controlName!=='splitPaymentStatus'">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox"
                                            id="type{{controlsN.controlName}}"
                                            [formControlName]="controlsN.controlName">
                                        <label class="form-check-label"
                                            for="{{controlsN?.controlName}}">{{controlsN.name}}
                                            <span aria-hidden="true" class="symbol required" *ngIf="controlsN.required" style="color:red;">*</span>
                                        </label>
                                    </div>
                                    <div style="display: block;"
                                        *ngIf="submitted && merchantFormControls?.[controlsN.controlName]?.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="merchantFormControls?.[controlsN.controlName]?.errors?.required">
                                            {{controlsN.name}} is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6"
                                    *ngIf="controlsN.type==='checkbox' && controlsN.controlName==='tncStatus'">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox"
                                            id="type{{controlsN.controlName}}" [formControlName]="controlsN.controlName"
                                            (change)="changeTnc($event)">
                                        <label class="form-check-label"
                                            for="{{controlsN?.controlName}}">{{controlsN.name}}
                                            <span aria-hidden="true" class="symbol required" *ngIf="controlsN.required" style="color:red;">*</span>
                                        </label>
                                    </div>
                                    <div style="display: block;"
                                        *ngIf="submitted && merchantFormControls?.[controlsN.controlName]?.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="merchantFormControls?.[controlsN.controlName]?.errors?.required">
                                            {{controlsN.name}} is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6"
                                    *ngIf="controlsN.type==='checkbox' && controlsN.controlName==='autoFlag'">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox"
                                            id="type{{controlsN.controlName}}" [formControlName]="controlsN.controlName"
                                            (change)="changeAuto($event)">
                                        <label class="form-check-label"
                                            for="{{controlsN?.controlName}}">{{controlsN.name}}
                                            <span aria-hidden="true" class="symbol required" *ngIf="controlsN.required" style="color:red;">*</span>
                                        </label>
                                    </div>
                                    <div style="display: block;"
                                        *ngIf="submitted && merchantFormControls?.[controlsN.controlName]?.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="merchantFormControls?.[controlsN.controlName]?.errors?.required">
                                            {{controlsN.name}} is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6"
                                    *ngIf="controlsN.type==='checkbox' && controlsN.controlName==='notificationApiEnableFlag'">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox"
                                            id="type{{controlsN.controlName}}" [formControlName]="controlsN.controlName"
                                            (change)="changeNotificationFlag($event)">
                                        <label class="form-check-label"
                                            for="{{controlsN?.controlName}}">{{controlsN.name}}
                                            <span aria-hidden="true" class="symbol required" *ngIf="controlsN.required" style="color:red;">*</span>
                                        </label>
                                    </div>
                                    <div style="display: block;"
                                        *ngIf="submitted && merchantFormControls?.[controlsN.controlName]?.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="merchantFormControls?.[controlsN.controlName]?.errors?.required">
                                            {{controlsN.name}} is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6"
                                    *ngIf="controlsN.type==='checkbox' && controlsN.controlName==='splitPaymentStatus'">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox"
                                            id="type{{controlsN.controlName}}" [formControlName]="controlsN.controlName"
                                            (change)="changeSplitPayment($event)">
                                        <label class="form-check-label"
                                            for="{{controlsN?.controlName}}">{{controlsN.name}}
                                            <span aria-hidden="true" class="symbol required" *ngIf="controlsN.required" style="color:red;">*</span>
                                        </label>
                                    </div>
                                    <div style="display: block;"
                                        *ngIf="submitted && merchantFormControls?.[controlsN.controlName]?.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="merchantFormControls?.[controlsN.controlName]?.errors?.required">
                                            {{controlsN.name}} is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6" *ngIf="controlsN.type==='number'">
                                    <label class="col-form-label" for="{{controlsN?.controlName}}">{{controlsN.name}}
                                        <span aria-hidden="true" class="symbol required" *ngIf="controlsN.required" style="color:red;">*</span>
                                    </label>
                                    <input type="number" class="form-control" id="{{controlsN?.controlName}}"
                                        placeholder="{{controlsN.name}}" [formControlName]="controlsN.controlName" />
                                    <div style="display: block;"
                                        *ngIf="submitted && merchantFormControls?.[controlsN.controlName]?.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="merchantFormControls?.[controlsN.controlName]?.errors?.required">
                                            {{controlsN.name}} is required.
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <div *ngIf="item.title==='Bank Details'" [style.display]="'none'">
                                <button type="button" class="btn bg-danger-custom" (click)="validateBank()">Validate</button>
                            </div>
                            <div class="row mb-0 mt-3" style="min-height: 380px" *ngIf="isSplitPayment && item.title==='Bank Details'">
                                <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                                    <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)"
                                        [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [tooltipShowDelay]="0" [rowData]="rowData"
                                        [rowModelType]="" [rowSelection]="'single'" style="width: 100%; height: auto;">
                                    </ag-grid-angular>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
    </div>
</div>